/**
 * Batch Genealogy — Report Ribbon / Summary.
 * Final-product identity + project context on the left; "All deviations (N)"
 * and "Export for QA (CSV)" actions plus the lineage-level counts
 * (Batches / Open Dev / Test Fail) on the right.
 */
import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';

const useStyles = makeStyles(() => ({
  card: { border: '1px solid #e5e7eb', borderRadius: 10, padding: 18, background: '#fff', marginBottom: 16 },
  eyebrow: { fontSize: 11, fontWeight: 700, letterSpacing: 0.6, color: '#ea580c', textTransform: 'uppercase' },
  pill: { fontSize: 11, fontWeight: 700, color: '#6d28d9', background: '#ede9fe', borderRadius: 12, padding: '2px 10px', marginLeft: 8 },
  prodName: { fontSize: 16, fontWeight: 700, color: '#000000', margin: '4px 0 10px' },
  metaRow: { display: 'flex', flexWrap: 'wrap', gap: 28 },
  metaLabel: { fontSize: 10.5, fontWeight: 700, letterSpacing: 0.5, color: '#000000', textTransform: 'uppercase' },
  metaVal: { fontSize: 13.5, color: '#333333', fontWeight: 600 },
  right: { display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 12, marginLeft: 'auto' },
  actions: { display: 'flex', gap: 10 },
  devBtn: {
    display: 'inline-flex', alignItems: 'center', gap: 8, border: '1px solid #e5e7eb', background: '#fff',
    borderRadius: 8, padding: '9px 14px', fontSize: 13, fontWeight: 700, color: '#b91c1c', cursor: 'pointer', fontFamily: 'inherit',
  },
  devCount: { background: '#fee2e2', color: '#b91c1c', borderRadius: 10, padding: '1px 8px', fontSize: 12, fontWeight: 700 },
  exportBtn: {
    display: 'inline-flex', alignItems: 'center', gap: 8, border: 'none',
    background: '#ea580c', color: '#fff', borderRadius: 8, padding: '10px 16px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
  },
  counts: { display: 'flex', gap: 10 },
  countBox: { textAlign: 'center', border: '1px solid #e5e7eb', borderRadius: 8, padding: '6px 16px', minWidth: 70 },
  countNum: { fontSize: 18, fontWeight: 700, color: '#333333' },
  countLbl: { fontSize: 10, fontWeight: 700, letterSpacing: 0.5, color: '#000000', textTransform: 'uppercase' },
}));

const ReportRibbon = ({ header, onAllDeviations, onExport }) => {
  const classes = useStyles();
  const meta = [
    ['CMO / SITE', header.cmoSite],
    ['PROJECT', header.project],
    ['CAMPAIGN', header.campaign],
    ['P.O.', header.po],
    ['QTY PRODUCED', header.qtyProduced],
  ];
  return (
    <div className={classes.card}>
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        <div style={{ flex: 1 }}>
          <span className={classes.eyebrow}>{header.stepLabel}</span>
          <span className={classes.pill}>{header.finalBatch}</span>
          <Typography className={classes.prodName}>{header.productName}</Typography>
          <div className={classes.metaRow}>
            {meta.map(([k, v]) => (
              <div key={k}>
                <div className={classes.metaLabel}>{k}</div>
                <div className={classes.metaVal}>{v}</div>
              </div>
            ))}
          </div>
        </div>

        <div className={classes.right}>
          <div className={classes.actions}>
            <button type="button" className={classes.devBtn} onClick={onAllDeviations}>
              <ReportProblemOutlinedIcon style={{ fontSize: 16 }} />
              All deviations
              <span className={classes.devCount}>{header.allDeviations}</span>
            </button>
            <button type="button" className={classes.exportBtn} onClick={onExport}>
              <GetAppIcon style={{ fontSize: 16 }} />
              Export for QA (CSV)
            </button>
          </div>
          <div className={classes.counts}>
            <div className={classes.countBox}>
              <div className={classes.countNum}>{header.counts.batches}</div>
              <div className={classes.countLbl}>Batches</div>
            </div>
            <div className={classes.countBox} style={{ borderColor: '#fde68a', background: '#fffbeb' }}>
              <div className={classes.countNum} style={{ color: '#b45309' }}>{header.counts.openDev}</div>
              <div className={classes.countLbl}>Open Dev</div>
            </div>
            <div className={classes.countBox} style={{ borderColor: '#fecaca', background: '#fef2f2' }}>
              <div className={classes.countNum} style={{ color: '#b91c1c' }}>{header.counts.testFail}</div>
              <div className={classes.countLbl}>Test Fail</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportRibbon;
